import { StepBar } from '../stepBar'

// TODO: 保存場所について検討
export const RESERVATION_STEPS = {
  SELECTION : '①',
  FORM: '②',
  CONFIRMATION: '③',
  COMPLETE: '④'
} as const;

type ReservationStepBarProps = {
  activeStepValue: typeof RESERVATION_STEPS[keyof typeof RESERVATION_STEPS] 
}

// 予約ステップバー
const ReservationStepBar = (props: ReservationStepBarProps) => (
  <StepBar
    activeStepValue={props.activeStepValue}
    stepValueLabels={[
      { value: RESERVATION_STEPS.SELECTION, label: '利用希望日' },
      { value: RESERVATION_STEPS.FORM, label: '必要事項入力' },
      { value: RESERVATION_STEPS.CONFIRMATION, label: '入力内容確認' },
      { value: RESERVATION_STEPS.COMPLETE, label: '完了' },
    ]}
  />
);
export default ReservationStepBar;